import { render, staticRenderFns } from "./RiskPermitSpecial.vue?vue&type=template&id=f13282cc&scoped=true"
import script from "./RiskPermitSpecial.vue?vue&type=script&lang=js"
export * from "./RiskPermitSpecial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13282cc",
  null
  
)

export default component.exports